module.exports = __webpack_public_path__ + "img/rechercheSousRecette.0aa7b5b4.png";